export default __webpack_public_path__ + "static/media/2sBlank.1d29ea49.mp3";